<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>시스템 관리</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">시스템 관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">사용자관리</p>
          <ul class="depth">
            <li><router-link to="/usermanagement" title="사용자관리">사용자관리</router-link></li>
            <li><router-link to="/teamlist" title="팀관리">팀관리</router-link></li>
            <li><router-link to="/departmentlist" title="부서관리">부서관리</router-link></li>
            <li><router-link to="/menulist" title="메뉴관리">메뉴관리</router-link></li>
            <li><router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link></li>
            <li><router-link to="/accessinfo" title="접속정보">접속정보</router-link></li>
            <!-- <li><router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">사용자관리</h3>
        <article>
          <div class="searchArea">
            <div class="total">
              총<span>{{ listData.length }}</span
              >건
            </div>
            <div class="searchBox">
              <search-box @emitSearch="searchBtn" @emitPerChange="changePerPage">
                <template slot="searchCondition">
                  <option value="1">아이디</option>
                  <option value="2">이름</option>
                  <option value="3">연락처</option>
                </template>
              </search-box>
            </div>
          </div>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table vertical-table">
              <table>
                <caption>
                  사용자관리 테이블
                </caption>
                <thead>
                  <tr>
                    <th scope="col">
                      <p class="checkbox">
                        <input type="checkbox" id="chk-on" class="hidden" v-model="allChecked" @change="checkedAll" />
                        <label for="chk-on"></label>
                      </p>
                    </th>
                    <th scope="col">번호</th>
                    <th scope="col">아이디</th>
                    <th scope="col">이름</th>
                    <!-- <th scope="col">업무</th> -->
                    <th scope="col">연락처</th>
                    <th scope="col">이메일</th>
                    <th scope="col">등록일</th>
                    <th scope="col">상태</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="nodate" v-if="nodata">
                    <td colspan="8">조회된 데이터가 없습니다.</td>
                  </tr>
                  <tr v-for="(item, index) in calData" :key="index" @click="view(item.empEsntlId)">
                    <td>
                      <p class="checkbox" @click="stopPropagation" @change="checkboxCkc()">
                        <input
                          type="checkbox"
                          :id="'itemCheck_' + item.empNo"
                          v-model="checkedValues"
                          :value="item.empEsntlId"
                        />
                        <label :for="'itemCheck_' + item.empNo"></label>
                      </p>
                    </td>
                    <td>{{ startOffset + index + 1 }}</td>
                    <td>{{ item.empNo }}</td>
                    <td>{{ item.empNm }}</td>
                    <!-- <td>행정</td> -->
                    <td>{{ item.empMobile }}</td>
                    <td>{{ item.empEmail }}</td>
                    <td>{{ item.regDttm | ptDateFormat }}</td>
                    <td>승인</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--btnArea-->
          <div class="btnArea txt-right">
            <button type="button" class="btn border" @click="deleteConfirm()">선택삭제</button>
            <button type="button" class="btn border" @click="$router.push('userenrollment')">등록</button>
          </div>

          <!-- 페이지네이션 -->
          <v-pagination v-model="curPageNum" :length="numOfPages"></v-pagination>
        </article>
      </div>
    </section>
    <alert-match v-show="showModal">
      <template #content>
        <p>{{ msg }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="deleteAction">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CloseBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert-match>
  </main>
</template>

<script>
import axios from '../../../util/axios.js';
import SearchBox from '../../../components/SearchBox.vue';
import AlertMatch from '../../../components/Alert01.vue';

export default {
  data() {
    return {
      listData: [],
      curPageNum: 1,
      dataPerPage: 10,
      searchCondition: '1',
      searchKeyword: '',
      nodata: true,
      allChecked: false,
      checkedValues: [],
      showModal: false,
      msg: '삭제 하시겠습니까?',
    };
  },

  mounted() {
    this.searchBtn();
  },

  components: {
    SearchBox,
    AlertMatch,
  },

  methods: {
    checkboxCkc() {
      if (this.calData.length === this.checkedValues.length) {
        this.allChecked = true;
        return;
      }
      this.allChecked = false;
    },

    stopPropagation(e) {
      e.stopPropagation();
    },

    checkedAll() {
      if (this.allChecked) {
        this.checkedValues = [];

        this.calData.forEach(element => {
          this.checkedValues.push(element.empEsntlId);
        });
      } else {
        this.checkedValues = [];
      }
    },

    deleteConfirm() {
      if (this.checkedValues.length > 1) this.showModal = true;
    },

    async deleteAction() {
      this.showModal = false;
      const apiParams = new FormData();
      apiParams.append('empEsntlId', this.checkedValues);
      const res = await axios('post', '/api/member/mberDelete.json', apiParams);
      const data = res.data;
      if (data.message == '정상적으로 삭제되었습니다.') {
        this.searchBtn();
      } else {
        alert('삭제에 실패하였습니다.');
      }
    },

    CloseBtn() {
      this.showModal = false;
    },

    async searchBtn(searchCondition, searchKeyword) {
      const res = await axios('get', '/api/member/list.json', {
        searchCondition: searchCondition,
        searchKeyword: searchKeyword,
        smu: true,
      });
      const data = res.data.resultList;

      if (!data) {
        this.listData = [];
        this.nodata = true;
        return;
      }
      this.listData = data;
      this.nodata = false;
    },

    changePerPage(dataPerPage) {
      this.dataPerPage = dataPerPage;
      this.curPageNum = 1;
    },

    view(empEsntlId) {
      this.$router.push({
        path: 'userview',
        query: { id: empEsntlId },
      });
    },
  },

  computed: {
    numOfPages() {
      return Math.ceil(this.listData.length / this.dataPerPage);
    },
    startOffset() {
      return (this.curPageNum - 1) * this.dataPerPage;
    },
    endOffset() {
      return this.startOffset + this.dataPerPage;
    },
    calData() {
      if (this.listData.length > 0) {
        return this.listData.slice(this.startOffset, this.endOffset);
      } else {
        this.nodata = true;
        return [];
      }
    },
  },
};
</script>
